import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class SessionStorageEventsService {
  public sessionsStorageUpdateEvent: EventEmitter<any> = new EventEmitter();
  public updateSubscriberEvent: EventEmitter<any> = new EventEmitter();

  constructor() {}

  // emit a success event toaster
  public emitUpdate() {
    this.sessionsStorageUpdateEvent.emit('update');
  }
}
